import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

export const Project = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();

  useEffect(() => {
    navigate(`/projects/${projectId}/pages`);
  }, []);

  return <div></div>;
};
